<div class="tool-call-hint__chip d-inline-flex align-items-center gap-1 mat-font-body-sm">
  @if (toolCall().hasResult) {
    <mat-icon class="mat-icon-sm mat-text-primary">check_circle</mat-icon>
  } @else {
    <span class="tool-call-hint__spinner"></span>
  }
  <span class="tool-call-hint__label">{{ toolCall().name }}</span>
</div>
